import { useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/admin/AuthContext";
import { apiError } from "@/lib/fda";

export default function AdminLogin() {
  const { user, login, loading } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  if (!loading && user) return <Navigate to={loc.state?.from || "/admin"} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      await login(email, password);
      nav(loc.state?.from || "/admin", { replace: true });
    } catch (e2) {
      setErr(apiError(e2.response?.data?.detail) || "Unable to sign in");
    } finally { setBusy(false); }
  };

  return (
    <div className="grain relative grid min-h-screen place-items-center bg-forest px-5" data-testid="admin-login-page">
      <form onSubmit={submit} className="relative w-full max-w-sm rounded-2xl bg-white p-8 shadow-2xl">
        <img src="/logo-on-light.png" alt="Freedom Debt Advice" data-testid="login-logo"
          className="h-16 w-auto max-w-full object-contain object-left" />
        <p className="mt-4 text-xs font-bold uppercase tracking-[0.18em] text-forest-soft">CRM sign in</p>
        <label htmlFor="email" className="mt-7 block text-sm font-semibold text-forest">Email</label>
        <input id="email" type="email" data-testid="login-email" value={email} autoComplete="username"
          onChange={(e) => setEmail(e.target.value)} required
          className="mt-2 w-full rounded-xl border-2 border-border px-4 py-3 text-sm" />
        <label htmlFor="password" className="mt-4 block text-sm font-semibold text-forest">Password</label>
        <input id="password" type="password" data-testid="login-password" value={password} autoComplete="current-password"
          onChange={(e) => setPassword(e.target.value)} required
          className="mt-2 w-full rounded-xl border-2 border-border px-4 py-3 text-sm" />
        {err && <p role="alert" data-testid="login-error" className="mt-4 rounded-lg bg-destructive/10 px-3 py-2 text-xs font-semibold text-destructive">{err}</p>}
        <button type="submit" disabled={busy} data-testid="login-submit"
          className="mt-6 inline-flex w-full items-center justify-center gap-2 rounded-full bg-forest px-6 py-3.5 text-xs font-extrabold uppercase tracking-wider text-sand disabled:opacity-60">
          {busy ? <><Loader2 className="h-4 w-4 animate-spin" /> Signing in…</> : "Sign in"}
        </button>
      </form>
    </div>
  );
}
